import { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { useCart } from '../context/CartContext.jsx'
import Logo from './Logo.jsx'
import AccountMenu from './AccountMenu.jsx'
import './Navbar.css'

const links = [
  { to: '/', label: 'Home', end: true },
  { to: '/products', label: 'Products' },
  { to: '/delivery', label: 'Delivery' },
  { to: '/partner', label: 'Partner' },
  { to: '/coas', label: 'COA' },
  { to: '/blog', label: 'Research' },
]

/** `restricted`: the visitor isn't an approved account yet, so only the logo
 *  and account control show (no store links, cart, or Shop button). */
export default function Navbar({ restricted = false }) {
  const { count, openCart } = useCart()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className="nav">
      <div className="container nav__inner">
        <Link to="/" className="nav__brand" onClick={() => setMenuOpen(false)}>
          <Logo />
        </Link>

        {!restricted && (
        <nav className={`nav__links ${menuOpen ? 'is-open' : ''}`}>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `nav__link ${isActive ? 'is-active' : ''}`
              }
              onClick={() => setMenuOpen(false)}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        )}

        <div className="nav__actions">
          {!restricted && (
          <button
            className="nav__icon"
            aria-label="Open cart"
            onClick={openCart}
          >
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none"
              stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"
              strokeLinejoin="round">
              <circle cx="9" cy="20" r="1.4" />
              <circle cx="18" cy="20" r="1.4" />
              <path d="M2 3h2l2.4 12.4a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L22 7H5.4" />
            </svg>
            {count > 0 && <span className="nav__badge">{count}</span>}
          </button>
          )}

          <AccountMenu onNavigate={() => setMenuOpen(false)} />

          {!restricted && (
          <Link to="/products" className="btn btn--primary nav__shop">
            Shop
          </Link>
          )}

          {!restricted && (
          <button
            className={`nav__burger ${menuOpen ? 'is-open' : ''}`}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span />
            <span />
            <span />
          </button>
          )}
        </div>
      </div>
    </header>
  )
}
